import PropTypes from "prop-types";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Select,
  Slider,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import Grid2 from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import OpacityIcon from "@mui/icons-material/Opacity";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import MKBox from "../../components/MKBox";
import { UPDATE_BASEMAP } from "../../store/actions";
import GridCard from "../Cards/GridCard";
import { setOpacity, setVisibleOrNot } from "../../utils/mapProcess";
import convertToValidHttps from "../../utils/convertToValidHttps";

const GridCardLayersData = ({ map, productionInfo }) => {
  const dispatch = useDispatch();
  const dataSelection = useSelector((state) => state.dataSelection);
  const vectorLayers = dataSelection.buildin;

  const [BaseMap, setBaseMap] = useState("mapbox");
  const handleBaseMap = (e) => {
    setBaseMap(e.target.value);
    dispatch({
      type: UPDATE_BASEMAP,
      value: { name: e.target.value },
    });
  };

  const [xyzLayersState, setxyzLayersState] = useState([]);

  useEffect(() => {
    const xyzLayersNames = dataSelection.selectedData;

    setxyzLayersState(xyzLayersNames.map((name) => ({ id: name, visible: true, opacity: 1 })));
  }, [dataSelection.selectedData]);

  const handlexyzLayersVisible = (clicked) => {
    const newList = [...xyzLayersState];
    const changeList = newList.map((dict) =>
      dict.id === clicked.target.id ? { ...dict, visible: clicked.target.checked } : dict
    );
    setxyzLayersState(changeList);
    setVisibleOrNot(map, clicked.target.id, clicked.target.checked);
  };

  const handlexyzLayersOpacity = (clicked, value) => {
    const newList = [...xyzLayersState];
    const changeList = newList.map((dict) =>
      dict.id === clicked.target.name ? { ...dict, opacity: value } : dict
    );
    setxyzLayersState(changeList);
    setOpacity(map, clicked.target.name, value);
  };

  const handleVectorLayersVisible = (clicked) => {
    setVisibleOrNot(map, clicked.target.id, clicked.target.checked);
  };
  const handleDrawLayerVisible = (clicked) => {
    setVisibleOrNot(map, clicked.target.id, clicked.target.checked);
  };

  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 48);
    }
  }, [parentRef]);

  return (
    <>
      <GridCard title="Data Layers" ref={parentRef}>
        <MKBox maxHeight={maxHeight} sx={{ height: 1, m: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
          <Grid2
            container
            xs={12}
            sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, justifyContent: "center" }}
          >
            <MKBox sx={{ overflow: "auto" }}>
              <FormControl sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
                <FormGroup>
                  <FormLabel focused={false}>BaseMap</FormLabel>
                  <Select
                    value={BaseMap}
                    displayEmpty
                    onChange={handleBaseMap}
                    sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, height: "30px", width: "180px" }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          width: "180px",
                        },
                      },
                    }}
                  >
                    <MenuItem value="mapbox">Mapbox</MenuItem>
                    <MenuItem value="bing-Aerial-labels">Bing</MenuItem>
                    <MenuItem value="openStreetMap">OpenStreetMap</MenuItem>
                    <MenuItem value="google">Google</MenuItem>
                  </Select>
                  <FormLabel focused={false} sx={{ mt: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
                    Boundary
                  </FormLabel>
                  {vectorLayers !== "" ? (
                    <FormControlLabel
                      key={vectorLayers}
                      control={
                        <Checkbox
                          defaultChecked
                          color="primary"
                          key={vectorLayers}
                          id={vectorLayers}
                          onChange={(e) => handleVectorLayersVisible(e)}
                        />
                      }
                      label={vectorLayers}
                      sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, color: "#444444" }}
                    />
                  ) : null}
                  {dataSelection.draw ? (
                    <FormControlLabel
                      key="draw"
                      control={
                        <Checkbox
                          defaultChecked
                          color="primary"
                          id="draw"
                          onChange={handleDrawLayerVisible}
                          sx={{ p: 0 }}
                        />
                      }
                      label="draw"
                      sx={{ m: 0, color: "#444444" }}
                    />
                  ) : null}
                  <FormLabel focused={false} sx={{ mt: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
                    Data
                  </FormLabel>

                  {xyzLayersState.length !== 0
                    ? xyzLayersState.map((dict) => (
                        <div key={dict.id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={dict.visible}
                                color="primary"
                                id={dict.id}
                                onChange={(e) => handlexyzLayersVisible(e)}
                                sx={{ p: 0 }}
                              />
                            }
                            label={dict.id}
                            sx={{ m: 0, color: "#444444" }}
                          />
                          <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                            <PanoramaFishEyeIcon style={{ fontSize: 18 }} />
                            <Slider
                              size="small"
                              width={1}
                              value={dict.opacity}
                              onChange={handlexyzLayersOpacity}
                              valueLabelDisplay="auto"
                              min={0}
                              step={0.01}
                              name={dict.id}
                              max={1}
                              disabled={!dict.visible}
                            />
                            <OpacityIcon style={{ fontSize: 18 }} />
                          </Stack>
                        </div>
                      ))
                    : null}
                  {xyzLayersState.length !== 0 ? (
                    <MKBox
                      component="img"
                      src={convertToValidHttps(
                        productionInfo.summaries.paths.abs_path + productionInfo.summaries.paths.legend_rel_path
                      )}
                      alt="Legend"
                      sx={{ width: "180px", height: 1 }}
                    />
                  ) : null}
                </FormGroup>
              </FormControl>
            </MKBox>
          </Grid2>
        </MKBox>
      </GridCard>
    </>
  );
};
GridCardLayersData.defaultProps = {
  map: null,

  productionInfo: {},
};

GridCardLayersData.propTypes = {
  map: PropTypes.oneOfType([PropTypes.any]),
  productionInfo: PropTypes.oneOfType([PropTypes.object]),
};
export default GridCardLayersData;
